/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reopen_ActivityInputs */

const en_task_reopen_activity = /** @type {(inputs: Task_Reopen_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reopen activity`)
};

const pt_br2_task_reopen_activity = /** @type {(inputs: Task_Reopen_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reabrir atividade`)
};

/**
* | output |
* | --- |
* | "Reopen activity" |
*
* @param {Task_Reopen_ActivityInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reopen_activity = /** @type {((inputs?: Task_Reopen_ActivityInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reopen_ActivityInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reopen_activity(inputs)
	return pt_br2_task_reopen_activity(inputs)
});